import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ColDef, GridApi, GridOptions, GridReadyEvent, RowClickedEvent } from 'ag-grid';
import { AdminService } from 'app/services/admin/AdminService';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-user-coaches-list',
  templateUrl: './user-coaches-list.component.html',
  styleUrls: ['./user-coaches-list.component.scss']
})
export class UserCoachesListComponent implements OnInit, OnDestroy {
  @Input() userId: string;

  public $rowData: Subject<any>;
  public coachesGrid: GridApi;
  public gridOptions = { 
    columnDefs: [
      { 
        field: 'FirstName', 
        // width: 300,  
        suppressSizeToFit: false,
        cellRenderer: params =>  {
          return params.value;
        }
      } as ColDef,
      { 
        field: 'LastName',
        // width: 300,
        suppressSizeToFit: false,
        cellRenderer: params =>  {
          return params.value;
        }
      } as ColDef,
      { 
        field: 'Email', 
        minWidth: 300,
        width: 400,
        suppressSizeToFit: true,
        cellRenderer: params =>  {
          return params.value;
        }
      } as ColDef
    ],
    rowData: [],
    onGridReady(event: GridReadyEvent) {
        event.api.sizeColumnsToFit();
    },
    overlayNoRowsTemplate: '<span> No related coaches... </span>',
    enableFilter: true,
    enableSorting: true,
    rowHeight: 45,
    headerHeight: 40,
    pagination: true,
    paginationPageSize: 25
  } as GridOptions;
  private subscriptions = new Array<Subscription>();

  constructor(
    private adminService: AdminService, 
    private toastr: ToastrService,
    private router: Router) { 
      this.$rowData = new Subject();

      // reload page when just user id change at route 
      this.router.routeReuseStrategy.shouldReuseRoute = () => {
        return false;
     }
  }

  ngOnInit() {
    this.getRelatedCoaches();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  public getRelatedCoaches(): void {
   this.subscriptions.push(
     this.adminService.getUserCoaches(this.userId)
      .subscribe((response) => {
        if (response.result.Result === 0) {
          this.toastr.error("We are sorry.  I'm unexpected error happened while trying to get the coaches", 'ELI');

          return;
        }
        const coaches = JSON.parse(response.result.Data);
        this.$rowData.next(coaches);
      },
      (error) => {
        this.toastr.error("We are sorry.  I'm unexpected error happened while trying to get the coaches", 'ELI');
      })
    );
  }

  public onRowClicked(event: RowClickedEvent): void {
    const coach = event.data;

    this.router.navigate(['/app/user_personal_data/', + coach.Id]);
  }
}
